"use client";
import {SessionProvider} from "next-auth/react";
import {OnbordaProvider} from "onborda";

export default function AuthProvider({ children }) {
    return (
        <OnbordaProvider>
            <SessionProvider>
                {children}
            </SessionProvider>
        </OnbordaProvider>
    );
}